<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Bursaries",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Fees Bursaries",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Student",
          sortable: true,
        },
        {
          key: "class",
          label: "Class",
          sortable: true,
        },
        {
          key: "term",
          label: "Term",
          sortable: true,
        },
        {
          key: "bursary",
          label: "Bursary",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        student: "",
        bursary: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        student: "",
        bursary: "",
        id: "",
      },
      studentError: "",
      bursaryError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesBursaries", "BursaryCategories", "SaveStatus"]),
    ...mapGetters("students", ["AllStudents1", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesBursaries ? this.FeesBursaries.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesBursaries ? this.FeesBursaries.length : 1;
  },
  methods: {
    ...mapActions({
      FetchBursaryCategories: "fees/fetchBursaryCategories",
      FetchBursaries: "fees/fetchBursaries",
      FetchStudents: "students/fetchStudents1",
      AddBursary: "fees/addFeesBursary",
      EditBursary: "fees/editFeesBursary",
      DeleteBursary: "fees/deleteFeesBursary",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesBursaries ? this.FeesBursaries.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },

    resetError() {
      this.studentError = "";
      this.bursaryError = "";
    },

    resetAddModal() {
      this.data.student = "";
      this.data.bursary = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.student = "";
      this.editdata.bursary = "";
      this.editdata.id = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.student = "";
      this.deletedata.id = "";
    },

    addBursary(modal) {
      if (this.data.student == "") {
        this.studentError = "Please Select a student";
        return;
      } else {
        this.studentError = "";
      }
      if (this.data.bursary == "") {
        this.bursaryError = "Bursary Category is required";
        return;
      } else {
        this.bursaryError = "";
      }
      this.modal = modal;
      this.AddBursary(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.student = values.item.sid;
      this.editdata.name = values.item.name;
      this.editdata.bursary = values.item.bid;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
      this.deletedata.class = values.item.amount;
    },
    deleteBursary(modal) {
      this.modal = modal;
      this.DeleteBursary(this.deletedata);
      this.closeModal(modal);
    },
    editBursary(modal) {
      if (this.editdata.name == "") {
        this.studentError = "Student is required";
        return;
      } else {
        this.studentError = "";
      }
      if (this.editdata.bursary == "") {
        this.bursaryError = "Bursary Category field can't be empty";
        return;
      } else {
        this.bursaryError = "";
      }
      this.modal = modal;
      this.EditBursary(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchBursaries();
    this.FetchBursaryCategories();
    this.FetchStudents();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_bursary')
        ) || getCurrentUser.role == 1
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Fees Bursaries For All Classes
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-exemption-modal
                  class="btn btn-primary btn-sm float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_bursary')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FeesBursaries ? FeesBursaries : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <!-- <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-setting-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_bursary')
                        )
                      "
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button> -->
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-setting-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_bursary')
                        )
                      "
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-exemption-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('assign_bursary')
          )
        "
      >
        <template #modal-title> Assign Bursary to Student</template>
        <div class="form-group mb-2">
          <label class="col-form-label">Student</label>
          <div class="input-group">
            <model-list-select
              :list="AllStudents1 ? AllStudents1 : []"
              v-model="data.student"
              option-value="id"
              option-text="names"
              class="mb-3"
              placeholder="Select Student"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="studentError">
            <em>{{ studentError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label class="col-form-label">Bursary</label>
          <div class="input-group">
            <model-list-select
              :list="BursaryCategories ? BursaryCategories : []"
              v-model="data.bursary"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Bursary"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="bursaryError">
            <em>{{ bursaryError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-exemption-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="addBursary('add-exemption-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-setting-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_bursary')
          )
        "
      >
        <template #modal-title>
          Edit Fees Bursary For {{ editdata.name }}</template
        >
        <div class="form-group mb-2">
          <label class="col-form-label">Bursary</label>
          <div class="input-group">
            <model-list-select
              :list="BursaryCategories ? BursaryCategories : []"
              v-model="editdata.bursary"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Bursary"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="bursaryError">
            <em>{{ bursaryError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editBursary('edit-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal
        id="delete-setting-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_bursary')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Fees Bursary For{{ deletedata.name }} of
            {{ thousandSeperater(deletedata.class) }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Fees Bursary For {{ deletedata.name }} ?
              Click Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteBursary('delete-setting-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
